<template>
  <div class="section">
    <div class="container">
      <h2 class="title" :style="'color:' + color">Project Goals</h2>
      <div class="columns">
        <div class="column is-4">
          <div class="goal-number">
            <svg height="56" viewBox="0 0 56 56" width="56" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <text :fill="color" font-family="Montserrat-SemiBold, Montserrat" font-size="24" font-weight="500">
                  <tspan x="23.428" y="37">1</tspan>
                </text>
                <circle cx="28" cy="28" r="27.5" :stroke="color"/>
              </g>
            </svg>
          </div>
          <div class="goal content">
            <slot name="goal1" class=""></slot>
          </div>
        </div>
        <div class="column is-4">
          <div class="goal-number">
            <svg height="56" viewBox="0 0 56 56" width="56" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <text :fill="color" font-family="Montserrat-SemiBold, Montserrat" font-size="24" font-weight="500">
                  <tspan x="21.016" y="37">2</tspan>
                </text>
                <circle cx="28" cy="28" r="27.5" :stroke="color"/>
              </g>
            </svg>
          </div>
          <div class="goal content">
            <slot name="goal2" class=""></slot>
          </div>
        </div>
        <div class="column is-4">
          <div class="goal-number">
            <svg height="56" viewBox="0 0 56 56" width="56" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <text :fill="color" font-family="Montserrat-SemiBold, Montserrat" font-size="24" font-weight="500">
                  <tspan x="21.016" y="37">3</tspan>
                </text>
                <circle cx="28" cy="28" r="27.5" :stroke="color"/>
              </g>
            </svg>
          </div>
          <div class="goal content">
            <slot name="goal3" class=""></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'color' ]
  }
</script>

<style scoped lang="scss">
  .section {
    padding-top: 0;
  }
  .goal-number {
    margin-bottom: 10px;
  }
  .goal {
    color: #696969;
    font-size:24px
  }
</style>